<particle-analytics-content [isNavContentPaneEnabled]="true"
                            [reportType]="'OIC'"
                            [solutionName]="'Home Page'"
                            [isResetButtonEnabled]="true"
                            [isEditButtonEnabled]="true"
>

</particle-analytics-content>
